const directDepositStringsEn = {
  header: 'Direct deposit',
  subHeader: 'Easily set up direct deposit to get paid up to 2 days early',
  dividerTitle: 'Quick options',
  copied: 'Copied!',
  exceptionalError: 'Oops! Something went wrong. Please try again later',
  sentryWarningMessage:
    'Attempted to copy null or undefined value to clipboard.',
  options: {
    setupAutomatically: {
      title: 'Set up automatically',
      description:
        'Just select your employer and log into your payroll provider for fast and easy set up.',
    },
    sendHrForm: {
      title: 'Send HR a direct deposit form',
      description:
        'Download a prefilled direct deposit form to share with your employer.',
    },
    copyPasteBankingInfo: {
      title: 'Copy and paste your banking info',
      description: 'Enter your account info into your employer’s HR portal.',
    },
    sendFormButton: 'Send form',
    sendFormTitle:
      'Send this form to your employer and they’ll get you set up.',
    copyAccountTitle: 'Account info',
    copyAccountSubTitle: 'Give these to your employer or government agency.',
    copyAccountAccountNumber: 'Account number',
    copyAccountRouting: 'Routing',
    copyAccountShowAccount: 'Show account number',
    directDepositFormTitle: 'Use a direct deposit form instead',
    directDepositFormSubTitle:
      'Send a prefilled direct deposit form to your employer or try again later.',
    directDepositFormViewButton: 'View form',
    directDepositFormTryLaterButton: 'Try later',
  },
  emptyDepositHistory: {
    title: 'Deposit history',
    description: 'Your previous direct deposits will appear here.',
  },
  pinwheelLaunchErrorAlertTitle:
    'Automatic setup is temporarily unavailable. Try manual setup instead—it’s easy.',
  disclosure:
    'We give access to direct deposits from employer & government payers on the day we receive them, typically up to 2 days earlier than your scheduled pay date.',
  LoaderScreenTitle: 'Switch your direct deposit to Varo',
  LoaderScreenBody:
    'Varo uses Pinwheel to make switching your direct deposit easy and instant.',
  LoaderScreenLockSubtext: 'Encrypted and secure',
  LoaderScreenSparkleSubtext: 'Fast and automatic',
  directDepositSetupIntroScreenTitle: 'Instantly switch your direct deposit',
  directDepositSetupIntroScreenAlertInline:
    'Borrow more and pay less with $800+ in monthly deposits',
  directDepositSetupIntroScreenDescription:
    'Just find your employer, payroll provider or government benefits, and we’ll get you set up quickly.',
  directDepositSetupIntroScreenButton: 'Find your employer',
  directDepositSetupIntroScreenPinwheelInfo:
    'Varo partners with Pinwheel for fast and secure setup.',
  directDepositSetupIntroScreenManualTitle: 'Set up direct deposit manually',
  directDepositSetupIntroScreenManualDescription:
    "Share these details with your employer or government benefits, or enter them directly into the app or website where you're linking your account.",
  directDepositSetupIntroScreenDownloadButton:
    'Download your direct deposit form',
  accountNumberCopied: 'Account number copied',
  routingNumberCopied: 'Routing number copied',
  accountNumberLabel: 'Account number',
  routingNumberLabel: 'Routing number',
  plusFortyThousand: '+40,000',
};
export default directDepositStringsEn;
